import { render, staticRenderFns } from "./RegisterBindingError.vue?vue&type=template&id=4ca58cdd&scoped=true&"
import script from "./RegisterBindingError.vue?vue&type=script&lang=js&"
export * from "./RegisterBindingError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca58cdd",
  null
  
)

export default component.exports